angular.module('gym.profile', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.profile', {
    url: '/profile/edit?tab&userId',
    controller: 'EditProfileController',
    reloadOnSearch: false,
    templateUrl: function($stateParams) {
      return `/gyms/${$stateParams.gymId}/profile/edit.template`;
    },
    resolve: {
      profile: ["$stateParams", "$http", function($stateParams, $http) {
        var params, url;
        url = `/gyms/${$stateParams.gymId}/profile/edit`;
        params = {
          user_id: $stateParams.userId
        };
        return $http.get(url, {
          params: params
        }).then(function(respone) {
          return respone.data;
        });
      }]
    }
  });
}]);
